import { Actions } from '../../interfaces'

import find from './find'
import { ExchangeRate } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { ExchangeRate },
  actions: { [ExchangeRate.name]: actions },
}
